import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { MERCHANT_SANDBOX } from './mocks/merchant-sandbox.mock';
// import { loanForm } from './mocks/loan-form/loan-form.collection.mock';
// import { MULTI_PROVIDER_FINISH_OR_MAKE_NEW_APPLICATION } from './mocks/dashboard/action-cards/multi-provider-finish-or-make-new-application.mock';
// import { welcome } from './mocks/welcome/welcome.collection.mock';
var apiUrl = env.VITE_API_URL;
export var merchantHandler = [
    http.get("".concat(apiUrl, "/merchant/*"), function () {
        return HttpResponse.json(MERCHANT_SANDBOX);
    }),
    // http.get(`${apiUrl}/merchant/*`, () => {
    // 	return HttpResponse.json(MULTI_PROVIDER_FINISH_OR_MAKE_NEW_APPLICATION);
    // }),
    // http.get(`${apiUrl}/merchant/*`, () => {
    // 	return HttpResponse.json(loanForm.JEDNOOSOBOWA);
    // }),
];
